import { useState } from "react";
import { createPortal } from "react-dom";

import DropdownField from "../../ui/editable/DropdownField";
import CompanyDetailModal from "./CompanyDetailModal";

import styles from "./CompanyPicker.module.css";

export const CREATE_COMPANY_LABEL = "＋ Crear empresa";
export const MISSING_ACCOUNT_MESSAGE =
  "Elegí la cuenta antes de crear la empresa.";

/**
 * Selector de empresa con la opción de crear una sin salir de la pantalla.
 *
 * Envuelve el desplegable de siempre y agrega el alta como última opción fija
 * del menú: el modal de empresas se abre en un portal, para que funcione dentro
 * de otros modales, y la empresa creada queda elegida.
 */
const CompanyPicker = ({
  items = [],
  value = null,
  loading = false,
  placeholder = "Buscar empresa...",
  className = "",
  accountId = null,
  disabled = false,
  onSearch,
  onLoadMore,
  onChange,
  onCreated,
}) => {
  const [creating, setCreating] = useState(false);
  const [missingAccountAsked, setMissingAccountAsked] = useState(false);
  const showMissingAccount = missingAccountAsked && accountId == null;

  const openCreate = () => {
    if (accountId == null) {
      setMissingAccountAsked(true);
      return;
    }
    setMissingAccountAsked(false);
    setCreating(true);
  };

  const handleSaved = (company) => {
    setCreating(false);
    if (!company?.id) return;
    onCreated?.(company);
    onChange?.(company);
  };

  return (
    <div className={styles.picker}>
      <DropdownField
        className={className}
        items={items}
        value={value}
        labelKey="name"
        placeholder={placeholder}
        searchable
        onSearch={onSearch}
        onLoadMore={onLoadMore}
        loading={loading}
        onChange={onChange}
        footerAction={
          disabled ? null : { label: CREATE_COMPANY_LABEL, onClick: openCreate }
        }
      />

      {showMissingAccount && (
        <p className={styles.error} role="alert">
          {MISSING_ACCOUNT_MESSAGE}
        </p>
      )}

      {creating &&
        createPortal(
          <div
            className={styles.modalLayer}
            onClick={(event) => event.stopPropagation()}
          >
            <CompanyDetailModal
              company={null}
              createMode
              accountId={accountId}
              onClose={() => setCreating(false)}
              onSaved={handleSaved}
            />
          </div>,
          document.body,
        )}
    </div>
  );
};

export default CompanyPicker;
